(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(81613);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CustomTestimonials_CustomTestimonials; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 12 modules
var makeStyles = __webpack_require__(11963);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/sx/sx.js
var sx = __webpack_require__(20525);
;// CONCATENATED MODULE: ./src/components/CustomTestimonials/Styles/styles.tsx



var StyledTypography = (0,styled/* default */.Z)(Typography/* default */.Z)((0,sx/* default */.Z)({
    color: "#000000DE",
    fontSize: "0.9rem"
}));
var StyledLink = (0,styled/* default */.Z)(Link/* default */.Z)((0,sx/* default */.Z)({
    color: "#e61e8f",
    cursor: "pointer",
    textDecoration: "underline"
}));
var StyledQuote = (0,styled/* default */.Z)(Typography/* default */.Z)((0,sx/* default */.Z)({
    fontSize: "32px",
    color: "#221133"
}));
var StyledQuote1 = (0,styled/* default */.Z)(Typography/* default */.Z)((0,sx/* default */.Z)({
    fontSize: "32px",
    color: "#221133",
    // fontFamily: "cursive",
    textAlign: "right",
    marginRight: "10px"
}));
var StyledCaption = (0,styled/* default */.Z)(Typography/* default */.Z)((0,sx/* default */.Z)({}));
var PaperDiv = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    display: "flex",
    flexDirection: "column"
}));
var PaperDiv1 = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    display: "flex",
    alignItems: "center"
}));
var PaperDiv2 = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    display: "flex",
    alignItems: "flex-end"
}));
var MainPaper = (0,styled/* default */.Z)(Paper/* default */.Z)((0,sx/* default */.Z)({
    padding: "1.2rem",
    borderRadius: "1rem",
    alignItems: "start",
    width: {
        xs: "250px",
        md: "250px",
        lg: "300px",
        xl: "350px"
    },
    overflowX: "auto"
}));
var StyledDiv = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    display: "flex",
    justifyContent: "center",
    position: "relative",
    width: {
        md: "100%",
        xl: "100%",
        sm: "100%",
        lg: "100%"
    },
    left: "50%"
}));
var Styledpaper = (0,styled/* default */.Z)(Paper/* default */.Z)((0,sx/* default */.Z)({
    height: 300,
    width: 300,
    position: "relative",
    borderRadius: "10px",
    "&:hover": {
        elevation: "19%",
        height: 400,
        cursor: "pointer",
        boxShadow: 20
    }
}));
var Wrapper = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    width: "90%",
    marginLeft: "10%",
    marginTop: "4%"
}));
var StyledProfile = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    justifyContent: "spaced-evenly",
    alignItems: "self",
    display: "flex",
    left: "10%",
    position: "absolute",
    bottom: "40px"
}));
var StyledTitle = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    justifyContent: "spaced-evenly",
    alignItems: "center",
    display: "flex",
    left: "26%",
    position: "absolute",
    bottom: "40px"
}));
var HeaderDiv = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: {
        xs: "65%",
        md: "55%"
    },
    color: "#221133"
}));
var MainHeaderDiv = (0,styled/* default */.Z)("div")((0,sx/* default */.Z)({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    alignItems: "center"
}));
var TextLink = (0,styled/* default */.Z)(Typography/* default */.Z)((0,sx/* default */.Z)({
    color: "#e61e8f",
    fontSize: {
        xs: "0.5rem",
        sm: "1rem",
        md: "1rem"
    },
    textDecoration: "underline"
}));
var useStyles = (0,makeStyles/* default */.Z)({
    root: {},
    companyname_typography: {
        color: "black",
        textAlign: "center",
        // fontFamily: "san-serif",
        fontStyle: "italic"
    },
    paper: {
        height: 400,
        width: 300,
        borderRadius: "10px",
        "&:hover": {
            elevation: "19%",
            height: 400,
            cursor: "pointer",
            boxShadow: 20
        }
    },
    wrapper: {
        width: "90%",
        marginLeft: "10%",
        marginTop: "4%"
    },
    quote: {
        color: "#221133"
    },
    profile: {
        marginTop: "30%",
        justifyContent: "spaced-evenly",
        alignItems: "self",
        display: "flex"
    }
});
/* harmony default export */ var styles = (useStyles);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/Pagination/Pagination.js + 8 modules
var Pagination = __webpack_require__(15054);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
;// CONCATENATED MODULE: ./src/components/CustomTestimonials/CustomTestimonials.tsx







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var CustomTestimonials = function(param) {
    var testimonials = param.testimonials, isClassic = param.isClassic, quantity = param.quantity, showPagination = param.showPagination;
    var classes = styles();
    var ref = (0,react.useState)(testimonials), testimonialitems = ref[0], setTestimonialitems = ref[1];
    var route = (0,router.useRouter)();
    var recenttestimonials1 = testimonialitems.slice(0, quantity);
    var ref1 = _slicedToArray(react.useState(recenttestimonials1), 2), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react.useState)(1), first = ref2[0], setFirst = ref2[1];
    var pages;
    //row perpage
    var ref3 = (0,react.useState)(0), rowsPerPage = ref3[0], setRowperPage = ref3[1];
    var emptyRows = rowsPerPage - Math.min(rowsPerPage, testimonials.length - page * rowsPerPage);
    var handleChange = function(event, value) {
        var recenttestimonials = testimonialitems.slice(value * quantity - quantity, quantity * value);
        setPage(recenttestimonials);
        setFirst(value);
    };
    var ref4 = (0,react.useState)([
        recenttestimonials1
    ]), rows = ref4[0], setrows = ref4[1];
    var maxPage = Math.ceil(testimonials.length / 6);
    var minPage = 1;
    var customgrid = [
        "span 20",
        "span 22",
        "span 23",
        "span 23",
        "span 22",
        "span 20"
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "testimonial",
        className: "section section--bg-world section--big",
        style: {
            background: "whitesmoke"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainHeaderDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderDiv, {
                    className: "testimonials-header__headline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "headline headline--gray headline--centered",
                                    children: "REFERANS"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pricing__headline headline headline--centered",
                                    children: "Şirketler iskibris sever"
                                })
                            ]
                        }),
                        !showPagination && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLink, {
                            onClick: function() {
                                route.push("/testimonials");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink, {
                                    children: "Hepsini g\xf6r"
                                }),
                                " "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "custom-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row row--action header__top--height-reset",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "custom-wrapper header__top",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDiv, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "custom-wrapper__wrappergrid",
                                        children: page.map(function(item, i) {
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    padding: "0.2rem",
                                                    position: "relative",
                                                    display: "grid",
                                                    gridRowEnd: isClassic ? customgrid[i] : ""
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainPaper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaperDiv, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaperDiv1, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                                sx: {
                                                                                    width: 24,
                                                                                    height: 24
                                                                                },
                                                                                src: item === null || item === void 0 ? void 0 : item.company_image.url
                                                                            }),
                                                                            "\xa0\xa0",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                                                                variant: "h6",
                                                                                children: item.company_name
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuote, {
                                                                            children: "“"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                                                            children: item.text
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuote1, {
                                                                            children: "”"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaperDiv2, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                                            src: item.author_image.url
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        style: {
                                                                            marginLeft: "0.5rem"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                                                                variant: "body1",
                                                                                children: item.author_name
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                                                                                variant: "body2",
                                                                                children: item.author_title
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, item.id)
                                            }, item.id));
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center"
                                    },
                                    children: showPagination ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                        count: Math.ceil(testimonials.length / quantity),
                                        page: first,
                                        onChange: handleChange
                                    }) : ""
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var CustomTestimonials_CustomTestimonials = (CustomTestimonials);


/***/ }),

/***/ 85920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BusinessAccountForm; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42283);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37636);
/* harmony import */ var _hooks_useGtm__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75882);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31955);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(83321);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88204);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98456);
/* harmony import */ var _context_AppStateContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7095);
/* harmony import */ var _context_DispatchContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83594);
/* harmony import */ var _api_iskibris_client__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(13032);


















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BusinessAccountForm(props) {
    var tagEvent = (0,_hooks_useGtm__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().tagEvent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref5[0], setLoading = ref5[1];
    // const [loading, setIsAuthError] = useState(false)
    var AuthState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_AppStateContext__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).AuthState;
    var AuthDispatcher = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_DispatchContext__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).AuthDispatcher;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), serverErrors = ref1[0], setServerErrors = ref1[1];
    var SignupSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
        name: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().optional(),
        phone_number: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().matches(/\+?\d+$/).optional(),
        company_name: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required(),
        email: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        option: yup__WEBPACK_IMPORTED_MODULE_5__/* .number */ .Rx().required().nullable()
    });
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)({
        validationSchema: SignupSchema,
        defaultValues: {
            option: 4
        }
    }), register = ref2.register, handleSubmit = ref2.handleSubmit, errors = ref2.errors, setError = ref2.setError, setValue = ref2.setValue, clearErrors = ref2.clearErrors, watch = ref2.watch;
    // React.useEffect(() => {
    //   if (AuthState.isLoggedIn && !AuthState.user) {
    //     iskibris
    //       .get("/api/user/profile")
    //       .then(response => {
    //         const user = response.data
    //         setValue("name", user.full_name)
    //         setValue("phone_number", user.phone_number)
    //         setValue("email", user.email)
    //         AuthDispatcher({ type: "login" })
    //         AuthDispatcher({ type: "addUser", payload: user })
    //       })
    //       .catch(error => {})
    //   }
    // }, [AuthState.isLoggedIn, AuthDispatcher, AuthState.user, setValue])
    var url = (0,_lib_api__WEBPACK_IMPORTED_MODULE_6__/* .getIskibrisUrl */ .nV)("/api/employers/business-account");
    var cookieAuth = js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get("auth_token");
    var onSubmit = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, e) {
            var application;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        setServerErrors({});
                        setLoading(true);
                        application = {
                            name: data.name,
                            phone_number: data.phone_number.toString().replaceAll(" ", ""),
                            company_name: data.company_name,
                            email: data.email,
                            option: data.option
                        };
                        _ctx.next = 6;
                        return axios__WEBPACK_IMPORTED_MODULE_4___default().post(url, application, {
                            headers: {
                                "Authorization": "Bearer ".concat(cookieAuth),
                                "Accept": 'application/json'
                            }
                        }).then(function(res) {
                            if (application.option === "4") {
                                tagEvent({
                                    event: "generate_lead",
                                    data: {
                                        company_name: application.company_name
                                    }
                                });
                                var _NEXT_PUBLIC_APP_DOMAIN;
                                // Cookies.set("auth_token", res.data.auth_token, {
                                //   domain: process.env.NEXT_PUBLIC_APP_DOMAIN ?? ".iskibris.com",
                                //   sameSite: "None",
                                //   secure: true,
                                //   expires: 364
                                // })
                                js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].set */ .Z.set("is_employer", "true", {
                                    domain: (_NEXT_PUBLIC_APP_DOMAIN = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN : ".iskibris.com",
                                    sameSite: "None",
                                    secure: true,
                                    expires: 750
                                });
                            // AuthDispatcher({ type: "login" })
                            }
                            setLoading(false);
                            // AuthDispatcher({ type: "login" })
                            if (props.onSuccess) {
                                props.onSuccess(application);
                            }
                            if (!props.withoutRedirectToSuccess) {
                                router.push("/success");
                            }
                        }).catch(function(error) {
                            var ref, ref3, ref4;
                            tagEvent({
                                event: "company_activation_failed",
                                data: {
                                    user_name: application.name,
                                    company_name: application.company_name,
                                    error_code: error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status
                                }
                            });
                            if (!(error === null || error === void 0 ? void 0 : error.response)) {
                                setServerErrors(_objectSpread({}, serverErrors, {
                                    application_error: "Bir hata oluştu, internet bağlantınızın olduğunu teyit edip tekrar deneyiniz. aynı hata oluşmaya devam ediyorsa l\xfctfen destek takımımıza ulaşınız."
                                }));
                            }
                            if ((error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 500) {
                                setServerErrors(_objectSpread({}, serverErrors, {
                                    server_error: "Bilinmeyen bir hata oluştu, aynı hata oluşmaya devam ediyorsa l\xfctfen destek takımımıza ulaşınız."
                                }));
                            }
                            if ((error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 401) {
                                setServerErrors(_objectSpread({}, serverErrors, {
                                    authentication_error: "Kimlik bilgileriniz kayıtlarımızla eşleşmedi."
                                }));
                            }
                            if (error.response.data.errors) {
                                Object.keys(error.response.data.errors).forEach(function(key) {
                                    if (key === "message") {
                                        setServerErrors(_objectSpread({}, serverErrors, {
                                            generic_error: error.response.data.errors[key]
                                        }));
                                    } else {
                                        setError(key, {
                                            type: "server",
                                            message: error.response.data.errors[key]
                                        });
                                    }
                                });
                            }
                            setLoading(false);
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data, e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "form",
        id: "application-form",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__title",
                children: "İşletme Hesabı Oluştur"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                style: {
                    textAlign: "center"
                },
                children: "Formu doldurun İş Kıbrıs İşveren Hesabınızı oluşturalım"
            }),
            serverErrors.generic_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__error--panel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: serverErrors.generic_error
                })
            }, "error-panel-generic"),
            serverErrors.application_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__error--panel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: serverErrors.application_error
                })
            }, "error-panel-application_error"),
            serverErrors.server_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__error--panel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: serverErrors.server_error
                })
            }, "error-panel-server_error"),
            serverErrors.authentication_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__error--panel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: serverErrors.authentication_error
                })
            }, "error-panel-authentication_error"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                className: "form__inner",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            autoFocus: true,
                            type: "text",
                            id: "company_name",
                            name: "company_name",
                            label: "Firma Adı",
                            size: "small",
                            variant: "outlined",
                            inputRef: register({
                                required: {
                                    value: true,
                                    message: "Bu alan gereklidir."
                                }
                            })
                        })
                    }),
                    errors.company_name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "form__error",
                        children: errors.company_name.message
                    }, "eer-com-nam"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            id: "email",
                            label: "E-posta",
                            type: "text",
                            name: "email",
                            variant: "outlined",
                            size: "small",
                            inputRef: register({
                                required: {
                                    value: true,
                                    message: "Bu alan gereklidir."
                                },
                                pattern: {
                                    value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: "L\xfctfen doğru bir email giriniz"
                                }
                            })
                        })
                    }),
                    errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "form__error",
                        children: errors.email.message
                    }, "message-error"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            id: "phone_number",
                            size: "small",
                            variant: "outlined",
                            label: "Telefon numarası",
                            type: "tel",
                            name: "phone_number",
                            inputRef: register({
                                required: {
                                    value: true,
                                    message: "Bu alan gereklidir."
                                },
                                pattern: {
                                    value: /\+?\d+$/,
                                    message: "L\xfctfen doğru bir telefon numarası giriniz."
                                }
                            })
                        })
                    }),
                    errors.phone_number && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "form__error",
                        children: errors.phone_number.message
                    }, "form-error-id"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        style: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("select", {
                            name: "option",
                            className: "form__control",
                            ref: register,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                    value: "",
                                    children: "---"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                    value: "4",
                                    selected: true,
                                    children: "Benim i\xe7in deneme oluştur"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            type: "submit",
                            style: {
                                background: "#e61e8f",
                                color: "white"
                            },
                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                size: "30px",
                                style: {
                                    color: "white"
                                }
                            }, Math.random()) : "G\xf6nder"
                        }, Math.random())
                    }, Math.random())
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 14705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pricing; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30724);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_markdown__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Paper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55113);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83321);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_icons_material_Check__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27036);
/* harmony import */ var _hooks_useGtm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75882);










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Pricing(param) {
    var packages = param.packages;
    // console.log
    var orderedItems = packages === null || packages === void 0 ? void 0 : packages.sort(function(a, b) {
        return a.order < b.order;
    });
    var colors = [
        "#505050",
        "black",
        "#505050",
        "#FF8042"
    ];
    var marginTop = [
        "25%",
        "15%",
        "3%"
    ];
    var height = [
        500,
        520,
        500
    ];
    var marginTops = [
        "6%",
        "0%",
        "6%"
    ];
    var elevations = [
        3,
        20,
        3
    ];
    var border = [
        "none",
        "2px solid ",
        "none"
    ];
    var pricingbordercolor = [
        "none",
        "#a30e62",
        "none"
    ];
    var pricingbackgroundcolor = [
        "none",
        "#a30e62",
        "none"
    ];
    var pricingColorvariant = [
        "outlined",
        "contained",
        "outlined"
    ];
    var pricingButtonColor = [
        "#a30e62",
        "white",
        "#a30e62"
    ];
    var pricingTextBorderColor = [
        "#a30e62",
        "#a30e62",
        "#a30e62"
    ];
    var width = [
        280,
        280,
        280
    ];
    var widths = [
        280,
        280,
        550
    ];
    var ref2 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(true), 2), pageLoading = ref2[0], setPageLoading = ref2[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (!pageLoading) {
            var tagEvent = (0,_hooks_useGtm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().tagEvent;
            tagEvent({
                event: "view_item_list",
                data: {
                    item_list_name: "packages_list",
                    item_list_id: "packages_list",
                    items: packages
                }
            });
        }
    }, [
        pageLoading
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (pageLoading) {
            setPageLoading(false);
        }
    }, []);
    var singlePackageItem = function(label) {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "single-feature",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Check__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    size: 20,
                    className: "single-feature--icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body2",
                    children: label
                })
            ]
        });
    };
    var ref1;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "pricing",
        className: "section section--gray",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "headline headline--gray headline--centered",
                    children: "\xdcCRETLENDİRME"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pricing__headline headline headline--centered",
                    children: "Paketlerimiz"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    container: true,
                    justifyContent: "center",
                    spacing: 1,
                    children: orderedItems === null || orderedItems === void 0 ? void 0 : orderedItems.map(function(singlePackage, i) {
                        var ref;
                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                            item: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Paper__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    elevation: elevations[i],
                                    sx: {
                                        border: border[i],
                                        borderColor: pricingbordercolor[i],
                                        marginTop: marginTops[i],
                                        height: height[i],
                                        width: {
                                            xs: width[i],
                                            md: widths[i],
                                            lg: 360
                                        },
                                        backgroundColor: function(theme) {
                                            return theme.palette.mode === "dark" ? "#1A2027" : "#fff";
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            variant: "h5",
                                            style: {
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                color: colors[i]
                                            },
                                            children: singlePackage.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            variant: "h6",
                                            style: {
                                                textAlign: "center",
                                                fontWeight: "bold"
                                            },
                                            children: [
                                                singlePackage.price,
                                                " ",
                                                singlePackage.currency
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                            href: "/cart?add-to-cart=" + singlePackage.handle,
                                            onClick: function() {
                                                var handleClick = function(e) {
                                                    e.preventDefault();
                                                    router.push("/cart?add-to-cart=" + singlePackage.handle);
                                                };
                                                handleClick;
                                            },
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                style: {
                                                    justifyContent: "center",
                                                    alignItem: "center",
                                                    display: "flex"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    variant: pricingColorvariant[i],
                                                    size: "large",
                                                    style: {
                                                        color: pricingButtonColor[i],
                                                        borderColor: pricingTextBorderColor[i],
                                                        backgroundColor: pricingbackgroundcolor[i]
                                                    },
                                                    children: "Paket Satın Al"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: "".concat((ref1 = singlePackage === null || singlePackage === void 0 ? void 0 : singlePackage.content) !== null && ref1 !== void 0 ? ref1 : singlePackage === null || singlePackage === void 0 ? void 0 : (ref = singlePackage.package_details) === null || ref === void 0 ? void 0 : ref.content).trim().split("\n").map(function(item) {
                                                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: singlePackageItem(item)
                                                }, item));
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, Math.random()));
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        })
    }));
};


/***/ }),

/***/ 81613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./src/components/Header.js + 1 modules
var Header = __webpack_require__(77297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 9 modules
var Modal = __webpack_require__(66893);
// EXTERNAL MODULE: ./src/components/application-form.js
var application_form = __webpack_require__(22464);
// EXTERNAL MODULE: ./src/context/AppStateContext.js
var AppStateContext = __webpack_require__(7095);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js + 1 modules
var Fade = __webpack_require__(61424);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/components/business-account-form.jsx
var business_account_form = __webpack_require__(85920);
;// CONCATENATED MODULE: ./src/components/Hero.js








function Hero() {
    var ref = (0,react.useState)(false), overlayOpen = ref[0], setOverlayOpen = ref[1];
    var ref1 = (0,react.useState)(false), logged = ref1[0], setlogged = ref1[1];
    var cookie_auth = js_cookie/* default.get */.Z.get("auth_token");
    //add cookie auth here as well
    var AuthState = (0,react.useContext)(AppStateContext/* default */.Z).AuthState;
    (0,react.useEffect)(function() {
        if (cookie_auth == undefined || cookie_auth == null) {
            setlogged(false);
        } else {
            setlogged(true);
        }
    }, [
        cookie_auth
    ]);
    //displayed when not logged in
    var designbutton = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: function(e) {
                return setOverlayOpen(true);
            },
            className: "button button--pink",
            children: "Hemen başvur!"
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "large-hero",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/ezgif.com-gif-maker-scaled.webp",
                alt: "Coastal view of oceans and mountains",
                className: "large-hero__image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "large-hero__container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "large-hero__text-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "large-hero__subtitle",
                                    children: "Kuzey Kıbrıs‘ın Modern İş Arama Portalı"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "large-hero__title",
                                    children: "İşverenler! İş İlanlarınıza \xc7ok\xe7a Başvuru Alın"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "large-hero__cta",
                                    children: designbutton()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "large-hero__form-content",
                            children: AuthState.isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_account_form/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(application_form/* default */.Z, {})
                        }),
                        overlayOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                            open: open,
                            className: "modal",
                            onClose: function(e) {
                                return setOverlayOpen(false);
                            },
                            "aria-labelledby": "simple-modal-title",
                            "aria-describedby": "simple-modal-description",
                            closeAfterTransition: true,
                            BackdropComponent: Backdrop/* default */.Z,
                            BackdropProps: {
                                timeout: 5000
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                in: open,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "modal__paper",
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "modal__header-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                onClick: function(e) {
                                                    return setOverlayOpen(false);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 20 20",
                                                    fill: "currentColor",
                                                    width: 24,
                                                    height: 24,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                                        clipRule: "evenodd"
                                                    })
                                                })
                                            })
                                        }),
                                        AuthState.isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(business_account_form/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(application_form/* default */.Z, {})
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/Intro.js



function Intro() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section section--bg-world",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "intro",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "intro__description",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "intro__headline",
                                children: [
                                    "Kıbrıs‘ta İşg\xfcc\xfc var. İş Arayan da var. ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "İş Kıbrıs olarak K\xd6PR\xdc olmaya geldik."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "intro__text",
                                children: "İş Kıbrıs, Kıbrıs‘ta en b\xfcy\xfck sorunlardan birini \xe7\xf6zmek i\xe7in kolları sıvadı. İş arayan ve işverenleri buluşturabilmek i\xe7in onlarca teknoloji ve yazılım bu ama\xe7la geliştidi, y\xf6netiyor."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "https://www.innoviadigital.com",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "button",
                                        style: {
                                            marginTop: "10px"
                                        },
                                        children: "Biz kim miyiz?"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "intro__image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: "/iskibris-ss.png",
                            alt: "me",
                            width: "500",
                            height: "275"
                        })
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/components/Footer.js
var Footer = __webpack_require__(66278);
;// CONCATENATED MODULE: ./src/components/How-It-Works.js

function HowItWorks() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section section--white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    children: "SİSTEM NASIL \xc7ALIŞIYOR?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    children: [
                        "İş Kıbrıs ile \xc7alışırken ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Nasıl Başvuru Alıyoruz?"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row__medium-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icon-text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-text__icon",
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "headline headline--small",
                                        children: "\xdcye Olun"
                                    }),
                                    "İş Kıbrıs \xfcyeliğinizi yukardaki başvuru formunu doldurarak başlatabilirsiniz. Aşağıdaki paketlerimizden birini satın alarak ilan vermeye başlayabilirsiniz."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row__medium-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icon-text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-text__icon",
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "headline headline--small headline--centered",
                                        children: "İş İlanı Yayınlayın"
                                    }),
                                    "İlanınızı online olarak kolaylıkla yaklaşık 3dk i\xe7inde yayınlayabilirsiniz."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row__medium-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icon-text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-text__icon",
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "headline headline--small",
                                        children: "Başvuru Toplayın"
                                    }),
                                    "İlanlarınıza gelen başvurular size email ile g\xf6nderilecektir. İlaveten, Aday Y\xf6netimi yazılımımız ile bu başvruları filtreleyebilir ve b\xfct\xfcn başvuru s\xfcrecini y\xf6netebilirsiniz."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row__medium-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "icon-text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-text__icon",
                                        children: "4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "headline headline--small",
                                        children: "Aradığınız Kişileri Bulun"
                                    }),
                                    "Uygun adayları iş g\xf6r\xfcşmesine davet edin ve aradığınız elemana hızlı ve kolay bir şekilde erişin."
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/Features.js

function Features() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "features",
        className: "section section--gray",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "section-title generic-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "headline headline--centered",
                        children: "\xd6zelliklerimiz"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " generic-content-container features",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-item__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feature-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "feature-item__icon",
                                        src: "/isverene_ozel_sayfa.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "feature-item__title",
                                        children: "Email \xdczerinden Değerlendirme"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "feature-item__paragraph",
                                        children: "Size başvuran her bir aday i\xe7in size bir email g\xf6nderilmektedir. Bu email i\xe7erisinden adaylarınız hakkında hızlı bır geri bildirim vererek, pratik bir şekilde aday filtrelemesi yapabilirsiniz."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-item__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feature-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "feature-item__icon",
                                        src: "/toplu_mesaj_logo.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "feature-item__title",
                                        children: "Adaylara Toplu Mesaj G\xf6nderimi"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "feature-item__paragraph",
                                        children: [
                                            "Adaylarınıza yapacağınız bilgilendirmeler i\xe7in toplu mesaj sistemimiz sayasinde bu en zor s\xfcreci sadece 1 dakika i\xe7erisinde ger\xe7ekleştirebilirsiniz.",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-item__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feature-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "feature-item__icon",
                                        src: "/isverene_ozel_sayfa.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "feature-item__title",
                                        children: "İşverene \xd6zel Sayfa"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "feature-item__paragraph",
                                        children: "Aday Y\xf6netim Yazılımımız ile t\xfcm başvuru s\xfcrecini, kolaylıkla y\xf6netebileceksiniz. İşe alım aşamalarını kolaylıkla değiştirebilecek, adaylar \xfczerindeki g\xf6r\xfcş ve notlarını pratik bir şekilde iş arkadaşlarınız ile paylaşabileceksiniz."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-item__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feature-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "feature-item__icon",
                                        src: "/yapay_zeka_logo.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "feature-item__title",
                                        children: "Yapay Zeka ile Kolay Aday Arama"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "feature-item__paragraph",
                                        children: "G\xfcn\xfcn\xfcz\xfcn \xf6nemli bir kısmı adayları aramak ile ge\xe7tiğinin farkında olarak, bu s\xfcreci kolaylaştırmak i\xe7in yapay zeka teknolojilerinden de yararlanarak ufak tefek yazım hatalarında dahi, ya da başka kriterlerden aradığınız adayı kolaylıkla bulabilirsiniz."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-item__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feature-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "feature-item__icon",
                                        src: "/ise_alim.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "feature-item__title",
                                        children: "İşe Alım Yazılımı"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "feature-item__paragraph",
                                        children: "Aday Y\xf6netim Yazılımımız ile t\xfcm başvuru s\xfcrecini, kolaylıkla y\xf6netebileceksiniz. İşe alım aşamalarını kolaylıkla değiştirebilecek, adaylar \xfczerindeki g\xf6r\xfcş ve notlarını pratik bir şekilde iş arkadaşlarınız ile paylaşabileceksiniz."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-item__container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feature-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "feature-item__icon",
                                        src: "/arayuz_logo.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "feature-item__title",
                                        children: "Basit, Anlaşılır, İnteraktif Aray\xfcz"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "feature-item__paragraph",
                                        children: "Basit, anlaşılır ve son derecek interaktif aray\xfcz\xfcm\xfcz\xfc \xe7ok seveceksiniz. \xdcstelik, odak grubumuz ile s\xfcrekli g\xfcncelliyor geliştiriyoruz. Sizin de \xf6nerileriniz olursa dinlemeye hazırız."
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(37636);
;// CONCATENATED MODULE: ./src/components/MiniInfographic.js

function MiniInfographic(param) {
    var statistics = param.statistics;
    var ref, ref1, ref2, ref3;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section section--dark-blue infographic__outer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row__medium-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "data__value",
                                    children: [
                                        "".concat((ref = statistics === null || statistics === void 0 ? void 0 : statistics.users) !== null && ref !== void 0 ? ref : 56500),
                                        "+"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data__title",
                                    children: "KULLANICI SAYISI"
                                })
                            ]
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row__medium-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "data__value",
                                    children: [
                                        (ref1 = statistics === null || statistics === void 0 ? void 0 : statistics.jobs) !== null && ref1 !== void 0 ? ref1 : 12000,
                                        "+"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data__title",
                                    children: "M\xdcNHAL SAYISI"
                                })
                            ]
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row__medium-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "data__value",
                                    children: [
                                        (ref2 = statistics === null || statistics === void 0 ? void 0 : statistics.applications) !== null && ref2 !== void 0 ? ref2 : 325000,
                                        "+"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data__title",
                                    children: "BAŞVURU SAYISI"
                                })
                            ]
                        })
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row__medium-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "data",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "data__value",
                                    children: [
                                        (ref3 = statistics === null || statistics === void 0 ? void 0 : statistics.companies) !== null && ref3 !== void 0 ? ref3 : 900,
                                        "+"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data__title",
                                    children: "TİCARİ KULLANIM"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/components/pricing.js
var pricing = __webpack_require__(14705);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/components/OurClients.js


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function OurClient(param) {
    var clients = param.clients;
    var settings = {
        infinite: true,
        autoplaySpeed: 2000,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "testimonials",
        className: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "headline headline--centered",
                        children: "Referanslarımız"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "slider",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread({}, settings, {
                            children: clients.map(function(client, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "slider__item",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: client.logo.url
                                    })
                                }, client.logo.id);
                            })
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                style: {
                    borderColor: "white"
                }
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
var build_default = /*#__PURE__*/__webpack_require__.n(build);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/components/CookiesManager/CookiesManager.tsx




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _throw(e) {
    throw e;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function CookiesManager(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var ref = _slicedToArray(react.useState(), 2), cookieTimeout = ref[0], setCookieTimeout = ref[1];
    react.useEffect(function() {
        var timer = setTimeout(function() {
            setCookieTimeout(true);
        }, 4000);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            transitionDelay: "10s"
        },
        children: cookieTimeout ? /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
            location: "bottom",
            buttonText: "Kabul Et",
            declineButtonText: "Reddet",
            cookieName: "iskibriscookies",
            containerClasses: "cookieanimation",
            contentClasses: "cookieanimation",
            style: {
                background: "#221133",
                width: "100%"
            },
            overlay: true,
            buttonStyle: {
                color: "white",
                background: "#a30e62",
                fontSize: "13px"
            },
            enableDeclineButton: true,
            declineButtonStyle: {
                color: "white",
                background: "#a30e62",
                fontSize: "13px"
            },
            overlayStyle: {
                transitionDelay: "4s",
                transition: "width 4s"
            },
            overlayClasses: "cookieanimation",
            expires: 150,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                align: "center",
                children: " Bu web sitesi, kullanıcı deneyimini geliştirmek i\xe7in \xe7erezleri kullanır."
            })
        }) : ""
    }));
};

;// CONCATENATED MODULE: ./src/components/CookiesManager/index.tsx


// EXTERNAL MODULE: ./src/components/CustomTestimonials/CustomTestimonials.tsx + 1 modules
var CustomTestimonials = __webpack_require__(92167);
;// CONCATENATED MODULE: ./src/pages/index.tsx







// import Articles from "../components/Articles"








function pages_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function pages_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function pages_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function pages_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pages_slicedToArray(arr, i) {
    return pages_arrayWithHoles(arr) || pages_iterableToArrayLimit(arr, i) || pages_unsupportedIterableToArray(arr, i) || pages_nonIterableRest();
}
function pages_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return pages_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pages_arrayLikeToArray(o, minLen);
}
var __N_SSG = true;
function Home(props) {
    var ref = pages_slicedToArray(react.useState(), 2), prPackages = ref[0], setPrPackages = ref[1];
    var ref1 = pages_slicedToArray(react.useState(props.statistics), 2), prStatistics = ref1[0], setPrStatistics = ref1[1];
    react.useEffect(function() {
        if (props.statisticsError) {
            (0,api/* fetchEmployersAPI */.cD)("/api/employers/statistics").then(function(data) {
                setPrStatistics(data);
            }).catch(function(error) {
                console.log("Error fetching statistics: ", error);
            });
        }
    }, [
        props.statisticsError
    ]);
    react.useEffect(function() {
        if (props.packagesError || !prPackages) {
            (0,api/* fetchEmployersAPI */.cD)("/api/employers/packages").then(function(data) {
                var packages = data;
                packages = packages === null || packages === void 0 ? void 0 : packages.filter(function(pkg) {
                    return !pkg.is_hidden;
                });
                setPrPackages(packages);
            }).catch(function(error) {
                console.log("Error fetching packages: ", error);
            });
        }
    }, [
        props.packagesError,
        prPackages
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "İş Kıbrıs - İşverenler İ\xe7in"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniInfographic, {
                                statistics: prStatistics
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTestimonials/* default */.Z, {
                                testimonials: props.testimonials,
                                isClassic: false,
                                quantity: 3,
                                showPagination: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing/* default */.Z, {
                                packages: prPackages
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OurClient, {
                                clients: props.clients
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesManager, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
                ]
            })
        ]
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [160,724,951,261,393,699,795,464,774,888,179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);